/**
 * Push Notification Registration Utility
 * Handles service worker push subscription for YAS Connect
 */

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Generate VAPID-compatible applicationServerKey
// Using a fixed public key for the platform
const VAPID_PUBLIC_KEY = 'BNVGDf_SvhYrKQxK4N4KoI0Sh_rA4IKNhJj6g1v3eGN0QfhIfSIiPwIHqf0eFcRH0lOa6VlGpILQzIpEXF_D3Ns';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function requestNotificationPermission() {
  if (!('Notification' in window)) {
    console.log('Notifications not supported');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission === 'denied') {
    return false;
  }

  const permission = await Notification.requestPermission();
  return permission === 'granted';
}

export async function subscribeToPush() {
  try {
    const permission = await requestNotificationPermission();
    if (!permission) return null;

    const registration = await navigator.serviceWorker.ready;
    
    // Check for existing subscription
    let subscription = await registration.pushManager.getSubscription();
    
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
      });
    }

    // Send subscription to backend
    const token = localStorage.getItem('token');
    if (token) {
      await fetch(`${API_URL}/api/push/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ subscription: subscription.toJSON() })
      });
    }

    return subscription;
  } catch (error) {
    console.error('Push subscription failed:', error);
    return null;
  }
}

export async function unsubscribeFromPush() {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    
    if (subscription) {
      await subscription.unsubscribe();
    }

    const token = localStorage.getItem('token');
    if (token) {
      await fetch(`${API_URL}/api/push/unsubscribe`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
    }

    return true;
  } catch (error) {
    console.error('Push unsubscribe failed:', error);
    return false;
  }
}

export async function getPushStatus() {
  try {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      return { supported: false, enabled: false };
    }

    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();

    return {
      supported: true,
      enabled: !!subscription,
      permission: Notification.permission
    };
  } catch (error) {
    return { supported: false, enabled: false };
  }
}
